import { createSlice } from "@reduxjs/toolkit";

import { ALL } from "../../consts/sectionDetails";

import {
  resetSectionManagement,
  setSectionView,
  fetchDepotSectionWeek,
  editSection,
  updateSectionEdit,
  setSectionAsDefault,
  addSection,
  saveSection,
  cancelSectionEdit,
  setIsSectionEditValid,
  removeSection,
} from "./thunkActions";

const initialState = {
  loading: false,
  view: ALL,
  isRemovingSection: false,
  isSectionEditValid: true,
  sections: [],
  editSections: null,
  sectionEdit: null,
  sectionEditCopy: null,
};

export const sectionManagementSlice = createSlice({
  name: "sectionManagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetSectionManagement.fulfilled, () => initialState)
      .addCase(setSectionView, (state, action) => {
        state.view = action.payload;
      })
      .addCase(fetchDepotSectionWeek.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDepotSectionWeek.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchDepotSectionWeek.fulfilled, (state, action) => {
        state.sections = action.payload;
        state.loading = false;
      })
      .addCase(editSection.fulfilled, (state, action) => {
        const { section, sections } = action.payload;
        state.sectionEdit = section;
        state.sectionEditCopy = section;
        state.editSections = sections;
      })
      .addCase(updateSectionEdit.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSectionEdit.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSectionEdit.fulfilled, (state, action) => {
        state.loading = false;
        state.sectionEdit = action.payload;
      })
      .addCase(setSectionAsDefault.pending, (state) => {
        state.loading = true;
      })
      .addCase(setSectionAsDefault.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setSectionAsDefault.fulfilled, (state, action) => {
        const { sectionEdit, editSections } = action.payload;
        state.loading = false;
        state.sectionEdit = sectionEdit;
        state.editSections = editSections;
      })
      .addCase(addSection.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSection.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addSection.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload;
      })
      .addCase(saveSection.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveSection.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveSection.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload;
        state.editSections = null;
        state.sectionEdit = null;
        state.sectionEditCopy = null;
      })
      .addCase(removeSection.pending, (state) => {
        state.loading = true;
        state.isRemovingSection = true;
      })
      .addCase(removeSection.rejected, (state) => {
        state.loading = false;
        state.isRemovingSection = false;
      })
      .addCase(removeSection.fulfilled, (state, action) => {
        state.loading = false;
        state.isRemovingSection = false;
        state.sections = action.payload;
      })
      .addCase(cancelSectionEdit, (state) => {
        state.editSections = null;
        state.sectionEdit = null;
        state.sectionEditCopy = null;
      })
      .addCase(setIsSectionEditValid, (state, action) => {
        state.isSectionEditValid = action.payload;
      });
  },
});

const { reducer } = sectionManagementSlice;
export { initialState, reducer };
